import { render, staticRenderFns } from "./StandardButton.vue?vue&type=template&id=69b6051b&"
import script from "./StandardButton.vue?vue&type=script&lang=js&"
export * from "./StandardButton.vue?vue&type=script&lang=js&"
import style0 from "./StandardButton.vue?vue&type=style&index=0&id=69b6051b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports